import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import { fmtDate } from '../../../../utils/fmt';

const AnalyticsDataListDetails = () => {
  const columns = [
    { label: 'Metric Name', value: 'metric_name' },
    { label: 'Date', value: (item) => fmtDate(item.date) },
    { label: 'Value', value: 'value' },
    { label: 'Access Details', value: (id) => <button onClick={() => handleAccessDetails(id)}>Access Details</button> },
  ];

  const handleAccessDetails = (id) => {
    const encodedId = btoa(id);
    window.location.href = '/reporting/analytics/details/' + encodedId;
  };
  return <ListTemplate columns={columns} onAccessDetails={handleAccessDetails} fetchUrl={API_DOMAIN + API_ROUTES['analyticsData']} />;
};

export default AnalyticsDataListDetails;